package com.cybersoftsolution.cybersoftsolutionweb.components.layouts

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.api.imSubscriber
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.GoToTopButton
import com.cybersoftsolution.cybersoftsolutionweb.components.cards.DevelopmentModeCard
import com.cybersoftsolution.cybersoftsolutionweb.components.indicators.LoadingIndicator
import com.cybersoftsolution.cybersoftsolutionweb.components.indicators.OverlayLoadingIndicator
import com.cybersoftsolution.cybersoftsolutionweb.components.menus.MainMenuOverFlow
import com.cybersoftsolution.cybersoftsolutionweb.components.sections.FooterSection
import com.cybersoftsolution.cybersoftsolutionweb.components.sections.HeaderSection
import com.cybersoftsolution.cybersoftsolutionweb.components.sections.PageSection
import com.cybersoftsolution.cybersoftsolutionweb.components.sections.getSections
import com.cybersoftsolution.cybersoftsolutionweb.models.UserInfo
import com.cybersoftsolution.cybersoftsolutionweb.models.ui.HomePageUI
import com.cybersoftsolution.cybersoftsolutionweb.use_cases.isProductionModeUseCase
import com.cybersoftsolution.cybersoftsolutionweb.use_cases.subscribeUseCase
import com.cybersoftsolution.cybersoftsolutionweb.use_cases.unSubscribeUseCase
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.headerSectionHeight
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources
import com.cybersoftsolution.cybersoftsolutionweb.utils.WebStorage.getRememberedSubscriber
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.browser.window
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.w3c.dom.events.Event
import kotlin.math.abs


@Composable
inline fun HomePageLayout(
    isLoading: Boolean = false,
    authenticatedUserInfo: UserInfo? = null,
    crossinline displayAuthenticationDialog:() -> Unit = {},
    crossinline onScreenWidthChange: (Int) -> Unit = {},
    crossinline content: @Composable () -> Unit
){
    val breakpoint = rememberBreakpoint()
    val scope = rememberCoroutineScope()
    val sectionMenuItems by remember { mutableStateOf(getSections()) }

    var mainMenuOverFlowIsOpen by remember { mutableStateOf(false) }

    var screenWidth by remember{ mutableStateOf(screenWidthFull- 10) }
    var screenHeight by remember{ mutableStateOf(screenHeightFull) }


    var state by remember { mutableStateOf(HomePageUI())}



    var headerVisible by remember { mutableStateOf(true) }
    var lastScrollTop by remember { mutableStateOf(0) }

    DisposableEffect(Unit) {
        val scrollListener = { _: Event ->
            val scrollTop = window.pageYOffset
            if (abs(scrollTop - lastScrollTop) > 20){
                if (scrollTop > lastScrollTop && scrollTop > headerSectionHeight.value.toInt()) {
                    headerVisible = false
                } else if (scrollTop < lastScrollTop || scrollTop <= headerSectionHeight.value.toInt()) {
                    headerVisible = true
                }
                lastScrollTop = scrollTop.toInt()
            }
//            console.log("headerVisible[$headerVisible] scrollTop[$scrollTop]")
        }
        window.addEventListener("scroll", scrollListener)
        onDispose {
            window.removeEventListener("scroll", scrollListener)
        }
    }


        GoToTopButton(
            visible = !headerVisible,
            onCLick = { window.scrollTo(0.0, 0.0) }
        )





    //Check if is a subscriber
    getRememberedSubscriber().entries.forEach {


        scope.launch {
            if (it.value.isNotEmpty() && imSubscriber(it.value)?.data == true) {
                state = state.copy(
                    isSubscribe = it.key,
                    email = it.value
                )
            } else {
                state = state.copy(
                    isSubscribe = false,
                    email = it.value
                )
            }
        }


    }



        LaunchedEffect(Unit) {

            state = state.copy(
                 isProductionMode = isProductionModeUseCase()
            )

            window.onresize = {

//                window.scrollTo(0.0, 0.0)

                window.innerWidth.also {
                    screenWidthFull = it
                    screenWidth = screenWidthFull - 10

                }
                onScreenWidthChange(screenWidth)

                window.innerHeight.also {
                    screenHeightFull = it
                    screenHeight = screenHeightFull
                }
            }

        }

        Box(
            Modifier
                .fillMaxSize()
            ,
            contentAlignment = Alignment.TopStart
        ) {

            if (isLoading) {
                OverlayLoadingIndicator()
            }

            if (mainMenuOverFlowIsOpen) {
                MainMenuOverFlow(onMenuCloseClick = {mainMenuOverFlowIsOpen = false})
            }

            Column(
                verticalArrangement = Arrangement.Top,
                horizontalAlignment = Alignment.CenterHorizontally,
                modifier = Modifier
                    .fillMaxSize()
            ) {

                HeaderSection(
                    authenticatedUserInfo = authenticatedUserInfo,
                    searchText = state.searchText,
                    setSearchText = { state = state.copy(searchText = it) },
                    menuIcon = Resources.FaIconsClassName.Menu_ICO,
                    pageSection = PageSection.HeaderSection,
                    sections = sectionMenuItems,
                    setSectionVisibility = { id, visible ->
                        sectionMenuItems.first { it.id == id }.visible = visible
                    },
                    brandIcon = Resources.Images.icoLogo,
                    brandLogo = Resources.Images.brand,
                    onMenuClick = {mainMenuOverFlowIsOpen = !mainMenuOverFlowIsOpen},
                    displayAuthenticationDialog = { displayAuthenticationDialog() }
                )


                Box(
                    Modifier
                        .transition(
                            Transition.of(
                                property = "padding",
                                duration = 500.ms,
                                timingFunction = null,
                                delay = 500.ms
                            )

                        )
                        .width(100.percent)
                        .fillMaxHeight()
                        .padding(
                            top = (headerSectionHeight)
                        )
                    ,
                    contentAlignment = Alignment.TopCenter,
                ) {

                    when (state.isProductionMode) {
                        true -> {
                            content()
                        }
                        false -> {
                            Column(
                                horizontalAlignment = Alignment.CenterHorizontally,
                                verticalArrangement = Arrangement.Center,
                                modifier = Modifier
                                    .fillMaxSize()
                            ){
                                DevelopmentModeCard()
                            }
                        }
                        else -> {
                            Column(
                                horizontalAlignment = Alignment.CenterHorizontally,
                                verticalArrangement = Arrangement.Center,
                                modifier = Modifier
                                    .fillMaxSize()
                            ){
                                LoadingIndicator()
                            }
                        }
                    }

                }


                FooterSection(
                    pageSection = PageSection.FooterSection,
                    sections = getSections(),
                    //subscribe
                    email = state.email,
                    onEmailChange = {state = state.copy(email = it)},
                    isSubscribe = state.isSubscribe,
                    isSubscribing = state.isSubscribing,
                    onSubscribe = { email ->
                        scope.launch {
                            subscribeUseCase(
                                state = state,
                                setState = {state = it},
                                setIsSubscribing = {state = state.copy(isSubscribing = it)},
                                email = email
                            )
                        }

                    },
                    onUnSubscribe = { email ->
                        scope.launch {
                            unSubscribeUseCase(
                                state = state,
                                setState = { state = it },
                                setIsSubscribing = { state = state.copy(isSubscribing = it) },
                                email = email,
                            )
                        }
                    }


                )

            }

//            MyToastContainer{
//                MyToastMessage(
//                    id = toastBasicID,
//                    message = state.toastMessage.message,
//                    style = state.toastMessage.style
//                )
//
//            }



        }

    }